import axios from "axios";
import { signOut, getSession } from "next-auth/react";

let abortControllers = {};

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    locale: "ar",
    'ngrok-skip-browser-warning': '69420'
  },
});

// Request interceptor to add token and cancel duplicate requests
axiosInstance.interceptors.request.use(async (config) => {
  // Fetch user session
  const session = await getSession();

  // Add authorization token if available
  if (session?.token) {
    config.headers.Authorization = `Bearer ${session.token}`;
  }

  // // Override token for specific route
  // if (config.url === "/customer/home") {
  //   config.headers.Authorization = `Bearer ${process.env.NEXT_PUBLIC_API_STATIC_TOKEN}`;
  // }

  // Exclude specific endpoints from cancellation
  const excludedEndpoints = ['/peers/register', '/peers/heartbeat', '/peers/get', '/peers/status'];
  if (excludedEndpoints.includes(config.url)) {
    return config;
  }

  // Cancel duplicate requests
  if (abortControllers[config.url]) {
    abortControllers[config.url].abort();
  }

  const controller = new AbortController();
  abortControllers[config.url] = controller;
  config.signal = controller.signal;

  return config;
}, (error) => Promise.reject(error));

// Response interceptor to handle errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.code === "ERR_CANCELED") {
      return Promise.reject({ response: { data: { message: "Request cancelled" } } });
    } else if (error.response?.status === 401) {  // Fixed 4011 to 401
      await signOut();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// Function to cancel requests with a specific URL
export const cancelRequestWithUrl = (url) => {
  if (abortControllers[url]) {
    abortControllers[url].abort();
    delete abortControllers[url];
  }
};

export default axiosInstance;
